import Cookies from "js-cookie";

export const setCookie = (name: string, token: string) => {
  Cookies.set(name, token, {
    expires: 1,
    secure:
      typeof window !== "undefined" && window.location.protocol === "https:",
    sameSite: "lax",
  });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};
